import React from "react";
import { motion } from "framer-motion";
import { CheckCircle2Icon, RocketIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { IMAGES } from "../src/config";
const wins = ["Prospectar en frío con tono de nativo de Silicon Valley.", "Redactar propuestas de $5.000+ que suenan con autoridad absoluta.", "Cerrar tratos en el mercado más rico del mundo sin vivir en USA."];
export function SolutionSection() {
  return <section className="w-full bg-gradient-to-b from-[#12102a] to-[#0a0a1f] py-16" data-id="element-184" data-mp="12868167h8ux">
      <div className="mx-auto grid max-w-6xl items-center gap-10 px-4 sm:px-6 lg:grid-cols-2" data-id="element-185" data-mp="3t8526b0tquiq">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-186" data-mp="atmaem93qwue">
          <div className="inline-flex items-center gap-2 rounded-full bg-violet-500/15 px-4 py-1.5 text-xs font-semibold uppercase tracking-wider text-violet-300" data-id="element-187" data-mp="kstojbnnuvik">
            <RocketIcon className="h-4 w-4" data-id="element-188" data-mp="36bdzaw61cttp" />
            Presentamos
          </div>
          <h2 className="mt-4 font-display text-3xl font-extrabold leading-tight text-white sm:text-4xl" data-id="element-189" data-mp="3b970tbwe8znn">
            The Bilingual Sales Machine
          </h2>
          <p className="mt-3 text-lg text-slate-300" data-id="element-190" data-mp="3fdeulnhpl5sq">
            Esto no es un curso de inglés. Es un{" "}
            <span className="font-semibold text-white" data-id="element-191" data-mp="3k80vgwq5zfyk">Sistema de Guerra de Ventas</span>{" "}
            — el mapa exacto que usamos en Nexto Digital para posicionarte como un
            experto internacional y "hackear" la percepción del cliente.
          </p>

          <ul className="mt-6 space-y-3" data-id="element-192" data-mp="2v6w0qrj8ylg">
            {wins.map(w => <li key={w} className="flex items-start gap-3" data-id="element-193" data-mp="6vqqfmkq1o3w">
                <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-emerald-400" data-id="element-194" data-mp="bulilf4kwp0o" />
                <span className="text-slate-200" data-id="element-195" data-mp="bsqw3wdnsouh">{w}</span>
              </li>)}
          </ul>

          <CTAButton className="mt-8 items-start" size="md" data-id="element-196" data-mp="grbvjtl374hv" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.94
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="overflow-hidden rounded-2xl border border-white/10 shadow-2xl shadow-violet-900/30" data-id="element-197" data-mp="2cuqex2csy208">
          <img src={IMAGES.lifestyle} alt="Freelancer latino cerrando un contrato con un cliente de USA" className="h-full w-full object-cover" data-id="element-198" data-mp="2hu31rn3ob92t" />
        </motion.div>
      </div>
    </section>;
}